import {DRAWER as WORKDRAWER, DRAWER} from "./drawer";
import {U, __, TOOLTIP, JOBS, short_popup} from "./global";
import {USER} from "./user";
import {CARD} from "./card";
import {SHOWCASE} from "./showcase";
import Cookies from 'js-cookie';
import {GTM} from "./gtm";
import {SLR} from "./slr";

export const CABINET = {
    zsctimeout: false,
    zscss: '',
    selectedDeviceId: false,
    addBlocked: false,
    codeReader: {},
    sound_enabled: true,
    web_order_read: {},

    // swithc store
    switch_store: async function(was) {

        const response = await fetch('/aj', {
            method: 'POST',
            headers: {
                'X-Requested-With': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams({
                action: 'slr',
                to: 'switchstore',
                was: was
            })
        });
        return response.json();

    },

    zsc_submit_active()
    {
        const form = $(".b2b-return-goods");
        const sku = parseInt(form.find('[name=sku]').length > 0 ? form.find('[name=sku]').val() : 0);

        if (sku && form.find('.js-cabinet__label.cabinet__label-active').length > 0) {
            $(".go-to-wizard").addClass('active');
        } else {
            $(".go-to-wizard").removeClass('active');
        }
    },

    zscsearchgoods: function() {
        let val = $.trim($(".zsc-lookup-goods [type=text]").val());
        let type_search = 0;

        $(".zsc-lookup-goods .js-alert").addClass('hidden');

        // if ($(".b2b-return-goods [name=type]").val()==4 && $(".b2b-return-goods [name=type_search]").prop('checked'))
        //     type_search = 1;

        if (val.length > 2)
            $.post(
                '/aj',
                {
                    action: G.manager_logged ? 'slr' : 'u',
                    to: 'zsc',
                    case: 'search',
                    q: val,
                    type_search: type_search,
                    context: $(".zsc-lookup-goods select").val()
                },
                (data) => {

                    $(".zsc-lookup-goods .js-alert").addClass('hidden');

                    if (typeof data.items === "object" && data.items.length) {
                        $.each(data.items, function(i, item) {
                            $(".zsc-lookup-goods .product-list").append(
                                '<a href="#" data-sku="' + item.sku + '" data-image="' + item.image + '">' +
                                '<div class="image"><img src="' + item.image + '" /></div><span>' + item.title + '</span>' +
                                '</a>'
                            );
                        });

                    } else {
                        if (!(G.is_b2b)) {
                            $(".zsc-lookup-goods .js-alert").removeClass('hidden').html('Товар не знайдено. Ремонт неможливий.');
                        }
                    }

                    this.zsc_submit_active();
                    $(".product-chose").addClass('active');
                },
                'json'
            );
    },

    allow_zsc_submit: function() {
        let active = true;
        let w = $(".wizard");
        active = (w.find('>div').length == w.find('>div.valid').length) ? active : false;

        if ($(".b2b-return-goods [name=sss]").length)
            if ($.trim($(".b2b-return-goods [name=sss]").val())=='')
                active = false;

        if (!($(".b2b-return-goods [name=phone]").val().length==10))
            active = false;

        if (active)
            $(".b2b-return-goods .errorBlock").addClass('hidden');
    },

    history_append_item: function(order, query, container) {

        let all_html = '';
        let order_date = '';
        let was_warranty = false;
        let add_class = '';
        let return_allowed = 0;
        let order_guid = '';

        if (order.length > 0) {
            $.each(order, (__i, i) => {
                order_guid = i.oguid;

                query = typeof query === "string" ? query : '';
                query = query.toLowerCase();
                let reg = new RegExp(query, 'gi');
                let item = i;
                let r = item.s.substr(0, 1) == '-' ? true : false;
                item.sku = item.sku.toString();

                if (i.return_allowed && !r) {
                    return_allowed++;
                }

                let title = item.t;
                let pn = item.pn;

                title.toString();
                pn.toString();

                item.ss = typeof item.ss === "object" && item.ss.length ? item.ss : '';
                item._sku = item.sku;

                if (!(query == '')) {
                    var tempss = typeof item.ss === "object" ? item.ss.join('|') : '';
                    if (!(item.t.toLowerCase().indexOf(query) !== -1 || item.sku.toLowerCase().indexOf(query) !== -1 || tempss.toLowerCase().indexOf(query) !== -1 || item.pn.toLowerCase().indexOf(query) !== -1))
                        return false;

                    title = title.replace(reg, function (str) {
                        return '<font class="highlight-search">' + str + '</font>'
                    });
                    pn = pn.replace(reg, function (str) {
                        return '<font class="highlight-search">' + str + '</font>'
                    });

                    if (typeof item.ss === "object") {
                        $.each(item.ss, function (_i, _item) {
                            _item = _item.replace(reg, function (str) {
                                return '<font class="highlight-search">' + str + '</font>'
                            });
                        });
                    }

                    item._sku = item.sku.replace(reg, function (str) {
                        return '<font class="highlight-search">' + str + '</font>'
                    });
                }

                let ss = [];

                if (item.ss.length)
                    $.each(item.ss, function (i, _ss) {
                        if (!($.trim(item) == ''))
                            if (r) {
                                ss.push(_ss);
                            } else {
                                ss.push('<a href="#" data-sku="' + item.sku + '" data-ss="' + _ss + '" data-guid="' + item.dguid + '" class="highlight-search new-zsc" target="_blank" title="' + __('Створення заявки сервісному центру') + '">' + _ss + '</a>');
                            }
                    });

                if (r)
                    add_class = 'history-order-gray';

                var return_string = r ? '<div class="cabinet__badge cabinet__badge-red">' + __('Повернено') + '</div>' : '';
                var ss_string = ss.length ? '<div class="ss">' + __('Серійний номер') + ': <span>' + ss.join(', ') + '</span></div>' : '';
                var warranty = (!(typeof item.wr === "undefined") && !(item.wr == '')) ? '<div>' + __('Гарантія') + ':<span>' + item.wr + '</span></div>' : '';
                let classname = G.channel==1 ? 'make-zsc js-newzsc-im' : 'make-zsc new-zsc';
                var make_string = ss.length == 1 && !r ? '<div data-ss="' + item.ss.join(', ') + '" data-sku="' + item.sku + '" data-guid="' + item.dguid + '" class="' + classname + '" title="' + __('Створити звернення до сервісного центру') + '">' + __('Звернення до СЦ') + '</div>' : ''
                var currency = G.b2bmode ? item.cr : (item.cr == 'грн' ? 'грн' : '');

                let certificate = '';
                if (!(typeof item.certificate_link === "undefined"))
                    certificate = '<a class="download-certificate" href="' + item.certificate_link + '" >' + __('Завантажити сертифікат') + '</a>';

                let warranty_btn = '';
                if (!(typeof item.warranty === "undefined") && !was_warranty) {
                    was_warranty = true;
                    warranty_btn = '<a class="download-warranty" href="' + item.warranty + '" target="_blank">' + __('Гарантійний талон') + '</a>';
                }

                order_date = item.nicedate + '&nbsp;&nbsp;<strong>' + (item.n ? item.n : item.n1c) + '</strong>';

                all_html += '' +
                    '<div class="history__item clearfix">\n' +

                    '       <div class="history__image">' +
                    '           <a href="' + item.l + '" target="_blank"><img src="' + item.image + '" /></a>' +
                    '       </div>\n' +
                    '       <div class="history__title">' +
                    '           <a href="' + item.l + '" class="history__titlea" target="_blank">' + title + '</a>' +
                    '           <span class="sku">Код: <strong>' + item._sku + '</strong></span>' +
                    '           <span><strong>' + item.p + '&nbsp;' + currency + '</strong></span>' + return_string +
                    '       </div>' +

                    '   <div class="history__params">' +
                    '       <div>' +
                    '           ' + __('Кількість') + ':<span>' + Math.abs(item.c) + '</span>' +
                    '       </div>' +
                    '       <div>' +
                    '           ' + __('Сума') + ':<span>' + item.s + '</span>' +
                    '       </div>' + warranty +
                    '       <div>' +
                    '           ' + __('Код виробника') + ':<span>' + pn + '</span>' +
                    '       </div>' + ss_string + make_string + certificate + warranty_btn +
                    '   </div>' +
                    '</div>';
            });
        }

        if (all_html) {
            console.log(return_allowed);
            $(container).append(`<div class="item-date">${return_allowed > 0 ? `<a href="#" class="history__return js-returnorder" data-guid="${order_guid}">Повернути товар</a>` : ''}${order_date}</div><div class="history-order ${add_class}">${all_html}</div>`);
        }

    },

    submit_history_search: function(container) {
        let q = $(".search__history [type=text]").val();
        let counter = 0;

        $(container).empty();

        if (!(typeof JOBS.JOB_stash['history']==="undefined"))
            $.each(JOBS.JOB_stash['history'], (i, item) => {
                this.history_append_item(item, q, container);
                counter++;
            });

        if (!counter)
            $(container).html('<div class="alert">' + __('Пошук не дав результатів') + '</div>');

    },

    submit_surcharge: function(el) {
        el.empty();
        JOBS.init_JOB(
            '/aj',
            {
                action: 'u',
                to: 'surcharge',
            },
            function(result) {
                $(".update-date").html('Дата оновлення даних: '+result.time+'');

                if (typeof result.data === "object") {
                    let html = '';
                    var sum = [];

                    if (!(result.data.tsum.uah=='0' || result.data.tsum.uah=='0.00'))
                        sum.push(result.data.tsum.uah + ' грн');

                    if (!(result.data.tsum.usd=='0' || result.data.tsum.usd=='0.00'))
                        sum.push(result.data.tsum.usd + ' у.о.');

                    if (sum.length)
                        html += '<div class="u-unify opened clearboth">' +
                            '<div class="number">Борг всіх контрагентів: ' +
                            '<a href="javascript: void(null);" class="expand-button"><strong>' + sum.join('</strong></a>, <a href="javascript: void(null);" class="expand-button"><strong>') + '</strong></a></div>';

                    var sum = [];
                    if (!(result.data.sum.uah=='0' || result.data.sum.uah=='0.00'))
                        sum.push(result.data.sum.uah + ' грн');

                    if (!(result.data.sum.usd=='0' || result.data.sum.usd=='0.00'))
                        sum.push(result.data.sum.usd + ' у.о.');

                    if (sum.length)
                        html += '<div class="u-unify opened clearboth">' +
                            '<div class="number">Сума просрочених оплат: ' +
                            '<a href="javascript: void(null);" class="expand-button red"><strong>' + sum.join('</strong></a>, <a href="javascript: void(null);" class="expand-button red"><strong>') + '</strong></a></div>';

                    if (typeof result.data.items==="object" && Object.keys(result.data.items).length) {
                        html += '<div class="expand">';
                        html += '<div class="table-responsive"><table class="table" cellspacing="1"><thead><th colspan="2" class="white"></th><th class="white fixed" valign="bottom">у.о.</th><th class="white fixed" valign="bottom">грн.</th><th class="white fixed2" valign="bottom">Відтермінування (дні)</th><th class="white fixed" valign="bottom">Дата оплати</th></thead>';

                        $.each(result.data.items, function (date, data) {
                            let cl = data.od ? 'red' : '';
                            let susd = data.od ? (data.susd == '0' || data.susd == '0.00' ? '' : data.susd) : (data.t.susd == '0' || data.t.susd == '0.00' ? '' : data.t.susd);
                            let suah = data.od ? (data.suah == '0' || data.suah == '0.00' ? '' : data.suah) : (data.t.suah == '0' || data.t.suah == '0.00' ? '' : data.t.suah);

                            html += '<thead><th colspan="2" class="' + cl + '">Ви повинні оплатити товари на суму:</th><th class="fixed ' + cl + '">' + susd + '</th><th class="fixed ' + cl + '">' + suah + '</th><th class="fixed2 ' + cl + '"></th><th class="fixed ' + cl + '">на ' + date + '</th></thead>';

                            $.each(data.v, function (i, item) {
                                var suah = data.od ? (item.suah == '0' || item.suah == '0.00' ? '' : item.suah) : (item.tsuah == '0' || item.tsuah == '0.00' ? '' : item.tsuah);
                                var susd = data.od ? (item.susd == '0' || item.susd == '0.00' ? '' : item.susd) : (item.tsusd == '0' || item.tsusd == '0.00' ? '' : item.tsusd);
                                var title = item.t;

                                if (!(item.rah=='' && item.rahd==''))
                                    title += '<br /><small>Згідно рахунку №' + item.rah + ' від ' + item.rahd + '</small>';

                                html += '<tr><td class="fixed ' + cl + '">' + (item.type == 1 ? 'Готівка' : 'Безготів.') + '</td><td class="' + cl + '" style="min-width: 200px;">' + title + '</td><td class="fixed ' + cl + '">' + susd + '</td><td class="fixed ' + cl + '">' + suah + '</td><td class="fixed2 ' + cl + '">' + item.d + '</td><td class="fixed ' + cl + '">' + date + '</td></tr>';
                            });

                        });

                        html += '</table></div>';
                        html += '</div></div>';
                    }

                    $(".b2b_surcharge").append(html);

                }
            },
            function(result) {
                $(".b2b_surcharge").html('Сталася помилка при оновленні даних, спробуйте пізніше');
            },
            function(result) {
                // destroy
            },
            el
        );
    },

    submit_balance: function(el) {
        el.empty();
        JOBS.init_JOB(
            '/aj',
            {
                action: 'u',
                to: 'balance',
                date: $(".sorting__item-active").data('val'),
            },
            function(result) {
                $(".b2b_balance").empty();
                $(".update-date").html('Дата оновлення даних: '+result.time+'');
                if (typeof result.data === "object")
                    if (result.data.length)
                        $.each(result.data, function(i, item){
                            $(".b2b_balance").append('' +
                                '<div class="item u-unify open-b2b-agreement clearboth" data-agreement="' + (item.agreement==null?'':item.agreement) + '"> <div class="top">' +
                                '<div class="title"> ' + (item.agreementName==null?'Не описаний':item.agreementName+'<span></span>') + '</div>' +
                                '<div class="number"> Поч. періоду: <a href="javascript: void(null);" class="expand-button"><strong>' + item.moneyStart + ' ' + item.currency + '</strong></a>, Кін. періоду:  <a href="javascript: void(null);" class="expand-button"><strong>' + item.moneyEnd + ' ' + item.currency + '</strong></a> </div>' +
                                '<div class="number"> Оборот: <a href="javascript: void(null);" class="expand-button"><strong>' + item.pm + ' ' + item.currency + '</strong></a>, Оплати та повернення:  <a href="javascript: void(null);" class="expand-button"><strong>' + item.pl + ' ' + item.currency + '</strong></a> </div>' +
                                '</div>' +
                                '<div class="expand hidden"></div>' +
                                '<div class="clearboth"></div>' +
                                '</div>');
                        });
            },
            function(result) {
                $(".b2b_balance").html('Сталася помилка при оновленні даних, спробуйте пізніше');
            },
            function(result) {
                // destroy
            },
            el
        );
    },

    submit_orders: function(el) {
        JOBS.init_JOB(
            '/aj',
            {
                action: 'u',
                to: 'orders',
                date: $(".orders-form select[name=date]").val(),
            },
            function(result) {
                $(".b2b_orders").empty();
                $(".b2b_orders").append('<p><small>Дата оновлення даних: '+result.time+'</small></p>');

                if (typeof result.data === "object")
                    if (result.data.length)
                        $.each(result.data, function(i, item){
                            var cl = 'red';

                            if (item.st=='Закритий')
                                cl = item.pc == 100 || item.pn ? 'green' : 'gray';
                            else {
                                cl = (item.pn || item.pc==100 || item.pv==100) ? 'yellow' : 'red';
                            }

                            item.pv = item.pv > 0 ? '<br>Відвантажено: ' + item.pv + '%' : '';
                            item.nttn = !(item.nttn=='') && !(item.sttn=='') ? 'Номер ТТН: <br class="hiddenMobile"/><strong>' + item.nttn + ' <br class="hiddenMobile"/>(' + item.sttn + ')' : '';
                            item.pn = item.pn ? 'Оплата за договором' : 'Оплачено: ' + item.pc + '%';

                            if (typeof item.ttn === "object" && Object.keys(item.ttn).length > 0)
                                $.each(item.ttn, function(_key, _ttn) {
                                    item.nttn = 'Номер ТТН: <br class="hiddenMobile"/><strong>' + _ttn.n + ' <br class="hiddenMobile"/>(' + _ttn.s + ')</strong>';
                                });

                            $(".b2b_orders").append('<div class="u-unify open-b2b-order clearboth" data-guid="' + item.guid + '"> ' +
                                '<div class="main"> ' +
                                '<a href="#" class="expand-btn expand-button"> <i class="fa fa-caret-down"></i> </a>' +
                                '<div class="left"> <div class="date"> <a href="javascript: void(null);" class="expand-button">'+item.dt+'</a> </div> <div class="number float-right-mobile"> <a href="javascript: void(null);" class="expand-button"> '+item.n+' <i class="fa fa-caret-down"></i> </a> </div> <div class="summ ' + cl + '">  <span>' + item.nttn + '</span> </div> <div class="status ' + cl + '"> ' + item.st + ' </div></div>' +
                                '<div class="right"> <div class="summ ' + cl + '"> ' + item.s + ' ' + item.cr + '<br /><span>' + item.pn + item.pv + '</span> </div> </div>' +
                                '</div>' +
                                '<div class="expand hidden"></div>' +
                                '<div class="clearboth"></div>' +
                                '</div>');
                        });
            },
            function(result) {
                $(".b2b_orders").html('Сталася помилка при оновленні даних, спробуйте пізніше');
            },
            function(result) {
                // destroy
            },
            el
        );
    },

    submit_service: function(el) {
        $(".service-list").empty();
        JOBS.init_JOB(
            '/aj',
            {
                action: G.channel==2 || G.channel==4 ? 'slr' : 'u',
                to: 'service',
                locale: G.locale_id,
                date: $(".sorting__item-active").data('val'),
            },
            function(data) {
                $(".service-list").append(data.html);
            },
            function(result) {
                $(".service-list").html('Сталася помилка при оновленні даних, спробуйте пізніше');
            },
            function(result) {
                // destroy
            },
            el
        );
    },

    // im
    im_orders: function(el) {
        $(".orders-list").empty();
        JOBS.init_JOB('/aj',
        {
            action: JOBS.action(),
            to: 'orders',
            locale: G.locale_id,
            date: $(".sorting__item-active").data('val'),
        },
    (result) => {
                let was_date = '';

                if (typeof result.data === "object" && result.data.length) {
                    $.each(result.data, (i, item) => {
                        let cl = '';

                        if (item.st=='Закритий')
                            cl = item.pc == 100 ? 'cabinet__badge-active cabinet__badge-green' : 'cabinet__badge-gray';
                        else {
                            cl = (item.pn || item.pc==100 || item.pv==100) ? 'cabinet__badge-active cabinet__badge-yellow' : 'cabinet__badge-active cabinet__badge-red';
                        }

                        // new colors logic
                        if (item.cs=='Товар отримано') {
                            // Замолвлення отримано
                            if (item.pc==100 && item.pv==100) {
                                // если оплачено и отгружено
                                cl = 'cabinet__badge-green';
                            } else {
                                cl = 'cabinet__badge-orange';
                            }
                        } else {
                            if (item.st=='Закритий') {
                                // если закрыт и товар не получен
                                cl = 'cabinet__badge-gray';
                            } else {
                                if (item.cs=='') {
                                    // новый заказ с пустым CustomerStatus
                                    cl = 'cabinet__badge-violet';
                                } else {
                                    cl = 'cabinet__badge-blue';
                                }
                            }
                        }

                        let invoice_button = '';

                        if (G.b2bmode && !(typeof item.in === "undefined") && item.in) {
                            invoice_button += '<form action="/u/printinvoice" method="post" class="download-invoice mb8" target="_blank">';
                            invoice_button += '<input type="hidden" name="guid" value="' + item.guid + '" />';
                            invoice_button += '<input type="hidden" name="invoice_number" value="' + item.in + '" />';
                            invoice_button += '<input type="hidden" name="date" value="' + item.df + '" />';
                            invoice_button += '<button class="order__paramcertificate" type="submit">Завантажити рахунок</button><div class="clearboth"></div></form>';
                        }

                        let ttn_output = '';

                        if (typeof item.ttn === "object" && Object.keys(item.ttn).length > 0) {
                            ttn_output = [];
                            $.each(item.ttn, function (_key, _ttn) {
                                ttn_output.push(_ttn.n);
                            });
                            ttn_output = 'ТТН:&nbsp;<strong>' + ttn_output.join(', ') + '</strong>';
                        }

                        if (item.ttn_n)
                            ttn_output = 'ТТН:&nbsp;<strong>' + item.ttn_n + '</strong>';

                        let pv = invoice_button!='' || ttn_output!='' || item.pv > 0 ? `
                            <div>
                                <div class="order__st">${invoice_button}${ttn_output}</div>
                                <div class="order__progress">
                                    <div class="order__progresstitle">Відвантажено: <strong>${item.pv}%</strong></div>
                                    <div class="order__progressline">
                                        <div style="width: ${item.pv}%"></div>
                                    </div>
                                </div>
                            </div>` : '';
                        
                        item.pc = item.s ? '<div>' +
                            '<div class="order__st">' + (__('Сума') + ':&nbsp;<strong>' + item.s + ' ' + item.cr + '</strong>') + '</div>' +
                            '' +
                            '<div class="order__progress">' +
                            '<div class="order__progresstitle">' + __('Оплачено') + ': <strong>' + item.pc + '%</strong></div>' +
                            '<div class="order__progressline">' +
                            '<div style="width: ' + item.pc + '%"></div>' +
                            '</div>' +
                            '</div>' +
                            '</div>' : '';

                        let amount = item.pv || item.pc ? pv + item.pc : '';

                        // if (!(was_date==item.dt)) {
                        //     was_date = item.dt;
                        //     $(".orders-list").append('<div class="item-date">' + was_date + '</div>');
                        // }

                        let warranty_btn = '';
                        if (!(typeof item.warranty === "undefined") && item.pv > 0)
                            warranty_btn = '<a class="download-warranty download-warranty-static hidden" href="' + item.warranty + '" target="_blank">' + __('Гарантійний талон') + '</a>';

                        $(".orders-list").append(
                            `<div class="item-date">${item.dt}</div>`
                        );

                        $(".orders-list").append(
                            '<div class="item ' + (item.conducted ? '' : '') + ' clearfix" data-guid="' + item.guid + '" data-mguid="' + item.dguid + '" data-df="' + item.df + '" data-tgtext="' + item.tgtext + '" data-closed="' + (item.st=='Закритий' ? 1 : 0) + '">' +
                            '   <div class="order__top">' +
                            '       <div>' +
                            '           <div class="service__title mb8">' + (typeof item.nc === "string" && !(item.nc=="") ? item.nc : item.n) + '<span></span></div>' +
                            '           <div class="cabinet__badge cabinet__badge-service  ' + cl + '">' + ((typeof item.cs==='string' && !(item.cs=='')) ? item.cs : item.st) + '</div>' +
                            '       </div><div class="order__amount">' +
                            '       ' + amount +
                            '       </div><div class="order__open">' +
                            '           <div class="order__wqbuttons">' +
                            '               <a href="#" class="typical typical-question js-order__question">' + __('Задати питання') + '</a>' + warranty_btn + '</div>' +
                            '           <a href="#" class="order__openbtn js-order__openbtn"><span>' + __('Детальніше') + '</span></a>' +
                            '       </div>' +
                            '   </div>' +
                            '   <div class="order__goods"></div>' +
                            '</div>');

                    });
                } else
                    $(".orders-list").html('<div class="alert">' + __('Пошук не дав результатів') + '</div>');
            },
            function(result) {
                $(".orders-list").html('<div class="alert">' + __('Сталася помилка при оновленні даних, спробуйте пізніше') + '</div>');
            },
            function(result) {

            },
            el
        );
    },

    im_salary: function(el) {
        $(".im_salary").empty()
        JOBS.init_JOB(
            '/aj',
            {
                action: JOBS.action(),
                to: 'salary',
            },
            function(result) {
                $(".im_salary").empty().html('<div class="ordersList"></div>');
                if (typeof result.data === "object" && result.data.length) {
                    $.each(result.data, function (i, item) {
                        var cl = item.pc == 100 ? '' : 'red';
                        var paid = item.p ? '<span class="green-icon"><i class="fa fa-check"></i></span>Оплачено' : '';

                        $(".im_salary .ordersList").append('<div class="u-unify"> ' +
                            '<div class="main"> ' +
                            '<div class="left no-expand">' +
                            '<div class="date">' +
                            '<a href="javascript: void(null);">' + item.dt + '&nbsp;&nbsp;<span class="red">' + item.a + '&nbsp;грн.</span></a>' +
                            '</div>' +
                            '<div class="status">' + paid + '</div>' +
                            '</div>' +
                            '<div class="right no-expand">' +
                            '<div class="number float-right-mobile">' +
                            '<a href="javascript: void(null);">' + item.pdt + '</a></div>' +
                            '<div class="status">' + item.s + '</div>' +
                            '</div>' +
                            '</div>' +
                            '<div class="expand hidden"></div>' +
                            '<div class="clearboth"></div>' +
                            '</div>');
                    });
                } else {
                    $(".im_salary").html('Заявок на РКО не знайдено.');
                }
            },
            function(result) {
                $(".im_salary").html('Сталася помилка при оновленні даних, спробуйте пізніше');
            },
            function(result) {

            },
            el
        );
    },

    ok_balance: function(el) {
        let container = $(".balance-list");
        container.empty();
        JOBS.init_JOB(
            '/aj',
            {
                action: JOBS.action(),
                to: 'balance',
                date: $(".sorting__item-active").data('val'),
            },
            function(result) {
                container.find('.expand').empty();

                var html = '<div class="update-date">' + __('Дата оновлення даних') + ': '+result.time+' &nbsp; <a href="#" class="typical balance-expand-all">' + __('Розгорнути все') + '</a></div>';

                var cc = 0;

                if (typeof result.data === "object" && result.data.length) {

                    html += '<div class="table-responsive"><table class="table" cellspacing="0">' +
                        '<thead>' +
                        '<th>' + __('Назва реалізації') + '</th>' +
                        '<th align="center" width="200">' + __('Коментар') + '</th>' +
                        '<th>' + __('К-сть') + '</th>' +
                        '<th>' + __('Ціна') + '</th>' +
                        '<th>' + __('Сальдо поч.') + '</th>' +
                        '<th>' + __('Прихід') + '</th>' +
                        '<th>' + __('Розхід') + '</th>' +
                        '<th>' + __('Сальдо кін.') + '</th>' +
                        '</thead>';

                    $.each(result.data, function(i, item){
                        var title = item.t;

                        cc++;
                        var base = container.index() + '-' + cc;
                        var goods ='';
                        var comment = '';

                        if (!(item.m==''))
                            comment = 'Менеджер: ' + item.m + '<br />';

                        if (!(item.isum=='') && item.isum > 0 && !(item.course=='') && item.course > 0)
                            comment += '<strong>' + item.isum + ' ' + item.curr + '</strong> по курсу <strong>' + item.course + '</strong>';

                        if (!(item.comment==''))
                            comment = item.comment + '<br />';

                        if (typeof item.goods === "object" && item.goods.length) {
                            var counter = 0;

                            $.each(item.goods, function(_i, _item){
                                if (!(typeof _item.c === "undefined") && _item.c) {
                                    counter++;
                                    var serials = [];

                                    if (!(typeof _item.ss === "undefined") && _item.ss.length)
                                        $.each(_item.ss, function(__i, serial){
                                            serials.push($.trim(serial));
                                        });

                                    var sku = (!(typeof _item.sku === "undefined") && _item.sku) ? '<strong>[' + _item.sku + ']</strong> ' : '';

                                    serials = serials.length ? '<strong>Серійні номери</strong><br />' + serials.join('<br />') : '';

                                    var pn_string = [];

                                    if (!(typeof _item.pn === "undefined") && !(_item.pn==''))
                                        pn_string.push('<strong>Артикул:</strong> ' + _item.pn);

                                    if (!(typeof _item.wr === "undefined") && !(_item.wr==''))
                                        pn_string.push('<strong>Гарантія:</strong> ' + _item.wr);

                                    pn_string = pn_string.length ? pn_string.join('<br />') : '';

                                    goods += '<tr class="highlighted detail-goods hidden" data-name="' + base + '">' +
                                        '<td colspan="2"><span>' + sku + _item.t + '</span><div class="row"><div class="col-xs-6">' + pn_string + '</div><div class="col-xs-6">' + serials + '</div></div></td>' +
                                        '<td valign="top">' + _item.c + 'шт.</td>' +
                                        '<td valign="top">' + _item.p.replace(' ', '&nbsp;') + '</td>' +
                                        '<td></td>' +
                                        '<td></td>' +
                                        '<td valign="top">' + _item.s.replace(' ', '&nbsp;') + '</td>' +
                                        '<td></td>' +
                                        '</tr>';
                                }
                            });

                            if (counter)
                                title = '<a href="#" class="open-closest-innertable" data-name="' + base + '">' + title + '</a>';
                        }
                        item.ps = item.ps=='0' || item.ps=='0.00' ? '' : item.ps.replace(' ', '&nbsp;');
                        item.pm = item.pm=='0' || item.pm=='0.00' ? '' : item.pm.replace(' ', '&nbsp;');
                        item.pl = item.pl=='0' || item.pl=='0.00' ? '' : item.pl.replace(' ', '&nbsp;');
                        item.pe = item.pe=='0' || item.pe=='0.00' ? '' : item.pe.replace(' ', '&nbsp;');

                        html += '<tr>' +
                            '<td class="min200">' + title + '</td>' +
                            '<td>' + comment + '</td>' +
                            '<td valign="top"></td>' +
                            '<td valign="top"></td>' +
                            '<td valign="top" align="center">' + item.ps + '</td>' +
                            '<td valign="top" align="center">' + item.pl + '</td>' +
                            '<td valign="top" align="center">' + item.pm + '</td>' +
                            '<td valign="top" align="center">' + item.pe + '</td>' +
                            '</tr>';

                        html += goods;
                    });

                    html += '</table></div>';
                } else
                    html += '<div class="alert">' + __('Данних за даний період не знайдено.') + '</div>';

                container.html(html);
            },
            function(result) {
                container.html('<div class="alert">' + __('Сталася помилка при оновленні даних, спробуйте пізніше') + '</div>').removeClass('hidden');
            },
            function(result) {

            },
            el
        );
    },

    im_history: function(el) {
        let container = $(".history-list");
        container.empty();
        JOBS.init_JOB(
            '/aj',
            {
                action: JOBS.action(),
                to: 'history',
                locale: G.locale_id,
                date: $(".sorting__item-active").data('val'),
            },
            (result) => {
                $(".history-list").empty();
                $(".update-date").html(__('Дата оновлення даних') + ': '+result.time);

                if (typeof result.data === "object")
                    if (Object.keys(result.data).length > 0) {
                        JOBS.JOB_stash['history'] = result.data;
                        this.submit_history_search('.history-list');
                    }
            },
            function(result) {
                container.html(__('Сталася помилка при оновленні даних, спробуйте пізніше')).removeClass('hidden');
            },
            function(result) {

            },
            el
        );
    },

    im_bonuses: function(el) {
        el.empty();
        JOBS.init_JOB(
            '/aj',
            {
                action: JOBS.action(),
                to: 'bonuses',
                locale: G.locale_id,
            },
            function(result) {
                el.html(result.html)
            },
            function(result) {
                el.html(__('Сталася помилка при оновленні даних, спробуйте пізніше')).removeClass('hidden');
            },
            function(result) {

            },
            el
        );
    },

    delivery_info: function(result, container, guid) {
        let warranty_btn = '';
        if (!(typeof result.data.warranty === "undefined") && result.data.pv > 0)
            warranty_btn = '<a class="download-warranty download-warranty-static mb8" href="' + result.data.warranty + '" target="_blank">' + __('Гарантійний талон') + '</a>';

        let show_decline_btn = true;

        /*
        Андрій Рабешко  [10:43 AM]: не показуємо коли:
        заказ закритий
        заказ скасований
        inCustomer=true
        4. якщо менеджер і він не є менеджером цього заказу
         */

        if (result.data.sto=='Закритий' || result.data.sto=='Відмінено') {
            show_decline_btn = false;
        }

        if (result.data.isc) {
            show_decline_btn = false;
        }

        if (G.manager_logged && container.data('mguid')!=G.manager.department_guid) {
            show_decline_btn = false;
        }

        let decline_btn = show_decline_btn ? '<a href="#" class="typical mb16 js-order__decline">' + __('Скасувати замовлення') + '</a>' : '';

        let return_btn = '';

        if (result.data.pv==100 && result.data.return_allowed) {
            return_btn = `<a href="#" class="history__return js-returnorder mb4" data-guid="${guid}">Повернути</a>`;
        }

        // change credit program
        let show_change_credit_btn = false;

        if (
            G.manager_logged &&
            result.data.sto != 'Закритий' &&
            result.data.sto != 'Відмінено' &&
            result.data.isc === false &&
            result.data.pc == 0
        )
        {
            show_change_credit_btn = true;
        }

        let change_credit_btn = '';

        if (show_change_credit_btn) {
            this.web_order_read[guid] = result.data;
            change_credit_btn = `<a href="#" class="typical mb4 js-orders__changecredit" data-job_id="${result.id}" data-sku="${result.data.skulist}" data-guid="${guid}" data-cp="${result.data.cp}">Змінити метод оплати</a>`;
        }

        let repeatorder_btn = G.manager_logged ? `<a href="#" class="typical mb4 js-orders__repeatorder" data-obj='${JSON.stringify(result.data.repeat_order)}'>Замовити ще раз</a>` : ``;

        let delivery_info =
            '<div class="order__info">' +
            '   <div class="order__subtitle mb12">' +
            '       <div class="order__bold">' + __('Деталі замовлення') + '</div>' +
            '       <div class="text-right display-flex flex-column order__infobtns">' + warranty_btn + decline_btn + return_btn + change_credit_btn + repeatorder_btn +
            '       </div>' +
            '   </div>' +
            '   <div class="order__param order__param-light mb12">' + __('Сума') + '<span>' + result.data.s + '&nbsp;' + result.data.cr + '</span>' + (result.data.delivery.payment > 0 ? ('<strong>' + 'Оплата при отриманні' + (result.data.s > result.data.delivery.payment ? ': ' + result.data.delivery.payment + ' грн' : '') + '</strong>') : '') + '</div>' +
            '   <div class="order__param order__param-light">' + __('Дата') + '<span>' + result.data.d + '</span></div>' +
            '   <div class="order__hr"></div>';

        if (result.data.pc==0 && result.data.cp_name!='')
            delivery_info = `${delivery_info}<div class="order__param order__param-light mb12">Спосіб оплати<span>${result.data.cp_name}</span></div><div class="order__hr"></div>`;

        if (result.data.delivery.carrier)
            delivery_info = delivery_info + '<div class="order__param order__param-light mb12">Спосіб доставки<span>' + result.data.delivery.carrier + '</span></div>';

        if (result.data.delivery.payer)
            delivery_info = delivery_info + '<div class="order__param order__param-light mb12">Вартість доставки<span>' + result.data.delivery.payer + '</span></div>';

        if (result.data.ttn_n)
            delivery_info = delivery_info + '<div class="order__param order__param-light mb12">Номер ТТН<span>' + result.data.ttn_n + (result.data.ttn_s ? ', ' + result.data.ttn_s : '') + '</span></div>';

        if (result.data.delivery.address)
            delivery_info = delivery_info + '<div class="order__param order__param-light mb12">Адреса доставки<span>' + result.data.delivery.address + '</span></div>';

        if (result.data.delivery.name)
            delivery_info = delivery_info +
                '<div class="order__param order__param-light mb12">' + __('Отримувач') + '<span>' + result.data.delivery.name + '</span></div>';

        if (result.data.delivery.phone)
            delivery_info = delivery_info +
                '<div class="order__param order__param-light ">' + __('Номер телефону') + '<span>' + result.data.delivery.phone + '</span></div>';

        delivery_info = delivery_info + '</div>';

        return delivery_info;
    }

}

export const WIZARD = {

    go_step: function(number) {
        $(".zsc .scroll").addClass('hidden');
        $(".zsc .steps a").removeClass('active').removeClass('checked');
        $(".zsc .scroll:eq(" + (number - 1) + ")").removeClass('hidden');
        $(".zsc .steps a:eq(" + (number - 1) + ")").addClass('active');

        if (number > 1)
            $(".zsc .steps a:eq(0)").addClass('checked');

        if (number > 2)
            $(".zsc .steps a:eq(1)").addClass('checked');

    },

    next: function() {
        let step = this.current();

        if (this.count_items() > (step.index()+1) && step.hasClass('valid')) {
            $("html, body").stop().animate({scrollTop: step.next().offset().top}, '200', 'swing');
        } else {

            if (step.hasClass('valid')) {
                if (this.count_items() == (step.index()+1)) {
                    // last
                    step.addClass('disabled').removeClass('active');
                    $(".b2b-return-goods [name=phone]").focus();
                }
            } else {
                step.find('.data .error').remove();
                step.find('.data').prepend('<div class="error"></div>');
            }
        }
    },

    validate: function() {
        let valid_counter = 0;
        let total_counter = $(".for-wizard .zsc-container").length;

        if ($(".for-wizard .zsc-container").length)
            $.each($(".for-wizard .zsc-container"), function(i, step) {
                step = $(step);
                let valid = false;

                if (step.data('min') > 0) {
                    let counter = 0;

                    if (step.find('input[type=checkbox], input[type=radio]').length)
                        $.each(step.find('input[type=checkbox], input[type=radio]'), function(i, item){
                            item = $(item);

                            if (item.prop('checked'))
                                counter++;
                        });

                    if (counter >= step.data('min') && counter <= step.data('max')) {
                        valid = true;
                        step.find('.title >span').addClass('hidden');
                    } else {
                        let message = __('Потрібно обрати мінімум') + ' <strong>' + step.data('min') + '</strong> ' + __('та максимум') + ' <strong>' + step.data('max') + '</strong> ' + __('опцій');

                        if (step.data('min')==step.data('max') && step.data('min')==1)
                            message = __('Оберіть потрібне значення');

                        step.find('.title >span').html(message).removeClass('hidden');
                    }
                } else
                    valid = true;

                if (valid)
                    valid_counter++;
            });

        return total_counter==valid_counter ? true : false;
    },

};

export const ZSC = {
    lookupRealizition: function(sku, ss) {
        const form = $(".js-newzsc-imsearchform");
        const submit = form.find('[type=submit]');

        if (submit.prop('disabled')) {
            return;
        }

        submit.prop('disabled', true).addClass('loading');
        form.find('.alert').removeClass('hidden').removeClass('alert-danger').html('Пошук реалізації');

        CARD.postData({
            action: 'u',
            to: 'zscim',
            case: 'lookuprealization',
            sku,
            ss
        }, '/u/zscim', 40000).then(data => {
            if (data.success) {
                // show next step
                let params = {
                    action: 'u',
                    to: 'zscim',
                    case: 'add',
                    sku,
                    guid: data.response.ДокументПродажи,
                    ss,
                };

                CABINET.zscss = ss;
                DRAWER.init('workdrawer-full workdrawer-zscim', params, () => {}, true);
            } else {
                form.find('.alert').addClass('alert-danger').removeClass('hidden').html(data.error_message);
            }
        }).catch((error) => {
            form.find('.alert').addClass('alert-danger').removeClass('hidden').html('Не вдалось знайти вказаний товар. Спробуйте ще раз');
        }).finally(() => {
            submit.prop('disabled', false).removeClass('loading');
        });
    },

    searchgoods: function() {
        const form = $(".js-newzsc-imsearchform");
        let sku = $.trim($("[name=sku][type=text]", form).val());

        $(".alert", form).addClass('hidden');

        if (sku.length > 2)
            $.post(
                '/aj',
                {
                    action: 'u',
                    to: 'zscim',
                    case: 'searchsku',
                    sku
                },
                (data) => {
                    $(".alert", form).addClass('hidden');

                    if (typeof data.items === "object" && data.items.length) {
                        $.each(data.items, function(i, item) {
                            $(".product-list", form).append(
                                `<a href="javascript: void(null);" class="js-newzsc-selectsku" data-sku="${item.sku}" data-image="${item.image}" data-use_the_serial_numbers="${item.use_the_serial_numbers}"  >
                                    <div class="image"><img src="${item.image}" /></div><span>${item.title}</span>
                                </a>`
                            );
                        });

                    } else {
                        $(".alert", form).removeClass('hidden').addClass('alert-danger').html('Товар не знайдено');
                    }

                    // finded
                    $(".product-chose").addClass('active');
                },
                'json'
            );
    }

}

export function init_CABINET_events() {

    console.info('cabinet loaded');
    jQuery(document).ready(function () {

        switch (G.command) {
            case 'b2b_balance':
                CABINET.submit_balance($(".b2b_balance"));
                break;

            case 'b2b_orders':
                CABINET.submit_orders($(".b2b_orders"));
                break;

            case 'b2b_surcharge':
                CABINET.submit_surcharge($(".b2b_surcharge"));
                break;

            case 'service_list':
                CABINET.submit_service($(".service-list"));
                break;

            case 'im_profile':
                $("select[name=sex], select[name=day], select[name=month], select[name=year], select[name=language], .user__contain select").select2({minimumResultsForSearch: Infinity});
                U.mask_inputs();
                break;
            case 'im_orders':
                CABINET.im_orders($(".orders-list"));
                break;

            case 'u_order':
                let container = $(".orders-list.zsc-page >.item");
                let params = {
                    action: 'u',
                    to: 'orderdata',
                    locale: G.locale_id,
                    guid: container.data('guid'),
                };

                if (container.parents('.zsc-by-guid').length)
                    params.phone = container.data('phone');

                JOBS.init_JOB(
                    '/aj',
                    params,
                    function (result) {
                        container.addClass('loaded opened').find('.order__goods').addClass('order__goods-active');
                        container.find('.order__openbtn').addClass('order__openbtn-active');

                        if (typeof result.data.goods === "object") {
                            container.find('.order__goods').append(
                                '<div class="order__goodstop"><div class="help help-large hiddenMobile">' + __('Підсумок замовлення:') + '</div>' + '</div>' +
                                '<div class="order__inner">' +
                                '<div class="order__goodslist"></div>' + CABINET.delivery_info(result, container, container.data('guid')) +
                                '</div>' +
                                '</div>'
                            );

                            if (container.find('.service__title').text() == '')
                                container.find('.service__title').html(result.data.n + '<span></span>');

                            GTM.fireStatistick('statistick', 'click', 'Orderlink', result.data.n);

                            $.each(result.data.goods, function (i, item) {

                                let link = typeof item.l === "undefined" ? 'javascript: void(null);' : item.l;
                                let img = typeof item.img === "undefined" ? '/themes/img/nophoto1.png' : item.img;

                                let certificate = '';

                                if (!(typeof item.certificate_link === "undefined"))
                                    certificate = '<div class="order__param"><span><a class="typical typical-certificate" href="' + item.certificate_link + '">' + __('Завантажити') + '</a></span></div>';

                                let ss = [];

                                if (item.ss.length)
                                    $.each(item.ss, function (i, _ss) {
                                        if (!($.trim(item) == ''))
                                            ss.push(_ss);
                                    });

                                let params = '';

                                if (item.cl)
                                    params = '<div class="order__param order__param-red">&nbsp;<span>' + __('Товар відмінено') + '</span>';
                                else
                                    params =
                                        '   <div class="order__param">' +
                                        '       ' + __('Ціна') + ':<span>' + item.p + '&nbsp;' + result.data.cr + '</span>' +
                                        '   </div>' +
                                        '   <div class="order__param">' +
                                        '       ' + __('Кількість') + ':<span>' + item.c + '&nbsp;шт.</span>' +
                                        '   </div>' +
                                        '   <div class="order__param order__param-sku">' +
                                        '       ' + __('Код товару') + ':<span>' + item.sku + '</span>' +
                                        '   </div>';

                                if (ss.length)
                                    params += '   <div class="order__param order__param-ss">' +
                                        '       ' + __('Серійний номер') + ':<span class="order__paramss js-order__paramss">' + ss.join(', ') + '</span>' +
                                        '   </div>';

                                container.find('.order__goodslist').append(
                                    '<div class="order__product">' +
                                    '   <div class="order__productimage"><a href="' + link + '" target="_blank" ><img src="' + img + '"></a></div>' +
                                    '   <div class="order__producttitle ' + (item.cl ? 'order__producttitle-strike' : '') + ' mb12"><a target="_blank" href="' + link + '">' + item.t + '</a></div>' +
                                    '   <div class="order__productparams">' + params + certificate +
                                    '</div>' +
                                    '</div>'
                                );
                            });
                        }

                        $("<div class=\"cabinet__badge cabinet__badge-service cabinet__badge-active cabinet__badge-green\">" + result.data.st + "</div>").appendTo(container.find('.order__top >div:first-child'));

                        let ttn_output = '';

                        if (result.data.ttn_n)
                            ttn_output = 'ТТН:&nbsp;<strong>' + result.data.ttn_n + '</strong>';

                        container.find('.order__amount').html(
                            '   <div>' +
                            '       <div class="order__st">' + ttn_output + '</div>' +
                            '       <div class="order__progress">' +
                            '           <div class="order__progresstitle">' + __('Відвантажено') + ': <strong>' + result.data.pv + '%</strong></div>' +
                            '           <div class="order__progressline">' +
                            '               <div style="width: ' + result.data.pv + '%"></div>' +
                            '           </div>' +
                            '       </div>' +
                            '   </div>' +
                            '<div>' +
                            '   <div class="order__st">' + __('Сума') + ':&nbsp;<strong>' + result.data.s + ' ' + result.data.cr + '</strong></div>' +
                            '   <div class="order__progress">' +
                            '       <div class="order__progresstitle">' + __('Оплачено') + ': <strong>' + result.data.pc + '%</strong></div>' +
                            '       <div class="order__progressline">' +
                            '           <div style="width: ' + result.data.pc + '%"></div>' +
                            '       </div>' +
                            '   </div>' +
                            '</div>');


                    },
                    function (result) {
                        if (container.parents('.zsc-page').length > 0) {
                            $(".orders-list.zsc-page").html(__('Сталася помилка при оновленні даних, спробуйте пізніше'));
                        } else {
                            container.find('.expand').html(__('Сталася помилка при оновленні даних, спробуйте пізніше')).removeClass('hidden');
                        }
                    },
                    function (result) {
                    },
                    container
                );
                break;

            case 'im_salary':
                CABINET.im_salary($(".salary-list"));
                break;

            case 'im_history':
                CABINET.im_history($(".history-list"));
                break;

            case 'im_bonuses':
                CABINET.im_bonuses($(".js-bonus__list"));
                break;

            case 'ok_balance':
                CABINET.ok_balance($(".balance-list"));
                break;
            default:
                break;
        }

        jQuery("body").on('click', '.camera-layout__sku', function (e) {
            e.preventDefault();
            $(this).remove();
        });

        jQuery("body").on('click', '.js-order__paramss', function (e) {
            e.preventDefault();
            U.copyToClipboard($(this).text());
        });


        $(".chose-date").click(function () {
            let btn = $(this);
            if (btn.hasClass('opened'))
                btn.removeClass('opened');
            else
                btn.addClass('opened');
        });

        if ($(".lookup-user-form").length) {
            try {
                $(".lookup-user-form [name=lookup]").mask("999 999-99-99", {autoclear: true});
            } catch (e) {
            }
            ;

            jQuery("body").on("keyup", ".lookup-user-form [name=lookup]", function (e) {
                e.preventDefault();

                let input = $(this);
                let form = input.parents('.lookup-user-form');
                let val = $(this).val().replace(/[^0-9.]/g, "");

                if (input.parent().hasClass('disabled'))
                    return;

                if (val.length == 10) {
                    input.parent().addClass('disabled').addClass('loading');

                    $.post(
                        '/aj',
                        {
                            action: 'slr',
                            to: 'finduserbyphone',
                            phone: val,
                        },
                        function (data) {
                            input.parent().removeClass('disabled').removeClass('loading');
                            if (data.users.length)
                                document.location.assign('/slr/orders');
                            else
                                form.find('.alert').removeClass('hidden').html(data.error != '' ? data.error : 'Кліент не знайдений');
                        },
                        'json'
                    );
                } else {
                    form.find('.alert').addClass('hidden');
                }
            });
        }

        jQuery("body").on("keyup", ".js-searchclient__preorder", function (e) {
            let input = $(this);
            let form = input.parents('.form-preorder');
            let val = input.val().replace(/[^0-9.]/g, "");

            if (val.length == 10) {
                form.find('[type=submit]').prop('disabled', true).addClass('loading');
                $.post(
                    '/aj',
                    {
                        action: 'slr',
                        to: 'finduserbyphone',
                        phone: val,
                    },
                    function (data) {
                        form.find('[type=submit]').prop('disabled', false).removeClass('loading');
                        if (data.users.length) {
                            data.users.forEach((item) => {
                                form.find('[name=name]').val(item.name);
                                form.find('[name=phone]').val('0' + item.phone);
                                form.find('[name=code]').val(item.code);
                            });
                        }
                    },
                    'json'
                );
            }
        });

        jQuery("body").on("click", ".destroy-user", function (e) {
            e.preventDefault();
            $.post(
                '/aj',
                {
                    action: 'slr',
                    to: 'destroyclient',
                },
                function (data) {
                    document.location.assign('/slr');
                },
                'json'
            );
        });

        // open drawer zsc master
        jQuery("body").on("click", ".new-zsc", function (e) {
            e.stopPropagation();
            e.preventDefault();

            let btn = $(this);
            let params = {
                action: 'u',
                to: 'zsc',
                case: 'add'
            };

            if (btn.data('sku'))
                params.sku = btn.data('sku');

            if (btn.data('guid'))
                params.guid = btn.data('guid');

            if (btn.data('ss')) {
                params.ss = btn.data('ss');
                CABINET.zscss = btn.data('ss');
            } else
                CABINET.zscss = '';

            DRAWER.init('workdrawer-full workdrawer-zsc zsc', params, () => {
                CABINET.zsc_submit_active();
            }, true);
        });

        // open drawer zsc master for IM
        jQuery("body").on("click", ".js-newzsc-im", function (e) {
            e.stopPropagation();
            e.preventDefault();

            let btn = $(this);
            const _case = btn.data('guid') ? 'add' : 'new';

            let params = {
                action: 'u',
                to: 'zscim',
                case: _case,
                sku: btn.data('sku'),
                guid: btn.data('guid'),
                ss: btn.data('ss'),
            };

            CABINET.zscss = btn.data('ss') ? btn.data('ss') : '';
            DRAWER.init('workdrawer-full workdrawer-zscim', params, () => {}, true);
        });

        // submit zsc master for IM
        jQuery("body").on("submit", ".js-newzsc-imform", function (e) {
            e.stopPropagation();
            e.preventDefault();

            const form = $(this);
            const submit = form.find('[type=submit]');

            if (submit.prop('disabled')) {
                return;
            }

            form.find('.alert').addClass('hidden');

            let errors = 0;

            const description = form.find('[name=description]');
            const appearance = form.find('[name=appearance]');
            const completeness = form.find('[name=completeness]');

            if ($.trim(description.val())=='') {
                errors++;
            }

            if ($.trim(appearance.val())=='') {
                errors++;
            }

            if ($.trim(completeness.val())=='') {
                errors++;
            }

            if (errors > 0) {
                form.find('.alert').removeClass('hidden').html(`Всі поля обов'язкові для заповнення`);
            } else {
                // submit
                submit.prop('disabled', true).addClass('loading');

                CARD.postData({
                    action: 'u',
                    to: 'zscim',
                    case: 'send',
                    description: description.val(),
                    appearance: appearance.val(),
                    completeness: completeness.val(),

                    subject_guid: form.find('[name=subject_guid]').val(),
                    ss: form.find('[name=ss]').val(),
                    sku: form.find('[name=sku]').val()
                }, '/u/zscim', 45000).then(data => {
                    if (data.success) {
                        WORKDRAWER.onpage_success(`
                        
                            <div class="scroll for-product">
                                <div class="wrap">
                                    <div class="exchange-thx"></div>
                                    <div class="small-text text-center">Принесіть пристрій у будь-який наш <a href="/stores" class="typical typical-large">магазин</a><br /><br />
        
                                        <strong>Або надішліть Новою поштою:</strong><br />
                                        Отримувач: ПП «КТС»<br />
                                        ЄДРПОУ: 32881326<br />
                                        м. Рівне, відділення №1<br />
                                        (вул. Кн. Володимира, 109К)<br />
                                        Тел.: 0673609573
                                    </div>
                                    <br /><br />
                                    <button type="button" class="btn success js-closepopups mt16">Закрити</button>
                                </div>
                            </div>
                        `);
                    } else {
                        form.find('.alert').removeClass('hidden').html('Проблема з відправкою заявки. Спробуйте ще раз');
                    }
                }).catch((error) => {
                    form.find('.alert').removeClass('hidden').html('Проблема з відправкою заявки. Спробуйте ще раз');
                }).finally(() => {
                    submit.prop('disabled', false).removeClass('loading');
                });
            }
        });

        // submit zsc master for IM
        jQuery("body").on("submit", ".js-newzsc-imsearchform", function (e) {
            e.stopPropagation();
            e.preventDefault();

            const form = $(this);
            const submit = form.find('[type=submit]');
            const sku = $.trim(form.find('[name=sku]').val());

            if (submit.prop('disabled')) {
                return;
            }

            form.find('.alert').addClass('hidden');
            const ss = $.trim(form.find('[name=ss]').val());
            const checkSS = !form.find('.js-forstep-2').hasClass('hidden');

            console.log('checkSS', checkSS);

            if ((checkSS && ss.length != 0) || !checkSS) {
                // шукаємо реалізацію
                ZSC.lookupRealizition(sku, ss);
            } else {
                form.find('.alert').addClass('alert-danger').removeClass('hidden').html('Серійний номер товару обовязковий');
            }
        });

        // remove finded sku
        jQuery("body").on("click", ".js-newzsc-imsearchform .selected-sku .remove", function (e) {
            e.stopPropagation();
            e.preventDefault();

            const form = $(this).parents('.js-newzsc-imsearchform');
            $(".selected-sku", form).empty().addClass('hidden');
            $(".alert", form).addClass('hidden');
            $(".js-forstep-1").removeClass('hidden');
            $(".js-forstep-2").addClass('hidden').find('[type=text]').val('');

            form.find('[type=submit]').addClass('hidden');
        });


        // select repair type
        jQuery("body").on("click", ".zsc__methodchange", function (e) {
            e.preventDefault();

            $(".zsc__methodhelp").addClass('hidden');
            $(".cabinet__label-zsc").removeClass('hidden cabinet__label-active');

            $(".zsc-lookup-goods").addClass('hidden');
        });
        // select repair type
        jQuery("body").on("click", ".js-cabinet__label", function (e) {
            e.preventDefault();
            let btn = $(this);
            let input = btn.find('input');
            input.prop('checked', true);

            btn.parent().find('.cabinet__label').not(btn).addClass('hidden');
            btn.addClass('cabinet__label-active');

            $(".zsc__methodhelp").removeClass('hidden');

            if (input.val() == '4')
                $(".zsc-lookup-goods .right-model").removeClass('hidden');
            else
                $(".zsc-lookup-goods .right-model").addClass('hidden');

            $(".zsc-lookup-goods").removeClass('hidden');
            $(".zsc-lookup-goods select").select2();

            CABINET.zsc_submit_active();
        });

        // keyup zscsearch goods
        jQuery("body").on("keyup", ".zsc-lookup-goods [type=text]", function (e) {
            e.preventDefault();

            clearTimeout(CABINET.zsctimeout);
            $(".zsc-lookup-goods .product-list").empty();
            $(".product-chose").removeClass('active');

            CABINET.zsctimeout = setTimeout(function () {
                CABINET.zscsearchgoods();
            }, 500);
        });

        // select zsc product
        jQuery("body").on("click", ".zsc-lookup-goods .product-list a", function (e) {
            e.preventDefault();
            let btn = $(this);

            $(".zsc-lookup-goods .alert").addClass('hidden');
            $(".product-chose").removeClass('active');
            $(".exists-goods").removeClass('hidden');
            $(".zsc-search-form").addClass('hidden');

            $(".b2b-return-goods .selected-sku").html(
                '<input type="hidden" name="sku" value="' + btn.data('sku') + '" required aria-required="true" />' +
                '<div class="image" style="background-image: url(' + btn.data('image') + ');"></div>' +
                '<a href="#" class="remove"></a>' +
                '<div class="title">' + btn.find('span').text() + '</div>' +
                '<small>' + __('Код товару') + ': ' + btn.data('sku') + '</small>'
            );

            CABINET.zsc_submit_active();
        });

        // keyup zscsearch goods
        jQuery("body").on("keyup", ".js-newzsc-imsearchform [name=sku][type=text]", function (e) {
            e.preventDefault();

            clearTimeout(CABINET.zsctimeout);
            $(".js-newzsc-imsearchform .product-list").empty();
            $(".product-chose").removeClass('active');

            CABINET.zsctimeout = setTimeout(function () {
                ZSC.searchgoods();
            }, 500);
        });

        // keyup zscsearch goods
        jQuery("body").on("click", ".js-newzsc-selectsku", function (e) {
            e.preventDefault();
            const btn = $(this);
            const form = btn.parents('form');

            $(".alert", form).addClass('hidden');
            $(".product-chose").removeClass('active');

            $(".exists-goods").removeClass('hidden');
            $(".js-forstep-1").addClass('hidden');

            $(".selected-sku", form).html(
                `<input type="hidden" name="sku" value="${btn.data('sku')}" required aria-required="true" />
                <div class="image" style="background-image: url(${btn.data('image')});"></div>
                <a href="#" class="remove"></a>
                <div class="title">${btn.find('span').text()}</div>
                <small>Код товару: ${btn.data('sku')}</small>`
            ).removeClass('hidden').find('[name=sku]').val(btn.data('sku'));

            form.find('[type=submit]').removeClass('hidden');

            console.log(btn.data());

            if (btn.data('use_the_serial_numbers')=='1') {
                form.find('.alert').removeClass('hidden').removeClass('alert-danger').html('Введіть серійний номер товару');
                $(".js-forstep-2").removeClass('hidden');
            } else {
                ZSC.lookupRealizition(btn.data('sku'), '');
            }
        });

        // another data
        jQuery("body").on("change", ".for-wizard input[type=radio], .for-wizard input[type=checkbox]", function (e) {
            let input = $(this);
            let label = input.parent();

            if (label.hasClass('for-other')) {
                if (input.prop('checked'))
                    label.parent().parent().find('.other').removeClass('hidden');
                else
                    label.parent().parent().find('.other').addClass('hidden');
            }
        });


        // remove finded sku
        jQuery("body").on("click", ".b2b-return-goods .selected-sku .remove", function (e) {
            e.stopPropagation();
            e.preventDefault();
            $(".b2b-return-goods .selected-sku [name=sku]").val('');
            $(".b2b-return-goods .exists-goods").addClass('hidden');
            $(".b2b-return-goods .zsc-lookup-goods").removeClass('hidden');
            $(".b2b-return-goods .zsc-search-form").removeClass('hidden');
            $(".b2b-return-goods .zsc-lookup-goods input[type=text]").val('');

            CABINET.zsc_submit_active();
        });

        // select zsc product
        jQuery("body").on("click", ".b2b-return-goods .go-to-wizard", function (e) {
            e.preventDefault();
            let btn = $(this);

            if (btn.hasClass('loading'))
                return;

            // validation
            let form = $(".b2b-return-goods");
            let sku = form.find('[name=sku]').val();

            if (!sku)
                sku = form.find('[name=q]').val();

            if (btn.hasClass('active') && !($.trim(sku) == '') && form.find('[name=type]:checked').length) {
                btn.addClass('loading');
                $(".b2b-return-goods .errorBlock").addClass('hidden');

                $.post(
                    '/aj',
                    {
                        action: G.manager_logged ? 'slr' : 'u',
                        to: 'zsc',
                        case: 'wizard',
                        sku: sku,
                        type: form.find('[name=type]:checked').val(),
                        ss: CABINET.zscss,
                        guid: form.find('[name=guid]').val(),
                    },
                    function (data) {
                        if (data.success) {
                            $(".zsc .for-wizard").html(data.html);
                            $(".zsc .for-delivery").html(data.delivery);
                            WIZARD.go_step(2);
                            U.mask_inputs();
                            $(".zsc .for-delivery [name=sss]").val(CABINET.zscss);

                            if (!form.find('[name=sku]').val())
                                form.find('[name=sku]').val(form.find('[name=q]').val());
                        } else {
                            $(".b2b-return-goods .errorBlock").html(data.error).removeClass('hidden');
                            $(".b2b-return-goods .compiled-str").addClass('hidden');
                        }

                        btn.removeClass('loading');

                        if (G.b2bmode)
                            try {
                                B2B.B2B.make_file_inputs();
                            } catch (e) {
                            }

                    },
                    'json'
                );

            } else {
                $(".b2b-return-goods .errorBlock").removeClass('hidden');
            }
        });

        // go to step 3
        jQuery("body").on("click", ".b2b-return-goods .go-to-step3", function (e) {
            e.preventDefault();
            e.stopPropagation();

            // validation
            if (WIZARD.validate()) {
                $(".b2b-return-goods .for-wizard .alert").addClass('hidden');
                WIZARD.go_step(3);
                U.mask_inputs();
            } else {
                // show error
                $(".b2b-return-goods .for-wizard .alert").removeClass('hidden');
            }

        });

        jQuery("body").on("click", ".zsc .steps a", function (e) {
            e.preventDefault();

            var current_step = $(".zsc .steps a.active").index();
            var step = $(this).index();

            if (step < current_step)
                WIZARD.go_step(step + 1);
        });

        jQuery("body").on("click", ".b2b-return-goods .left label", function (e) {

        });

        jQuery("body").on("change", ".b2b-return-goods [name=delivery]", function (e) {
            var label = $(this).parent();

            if (label.hasClass('own-delivery'))
                $(".chose-own-delivery").removeClass('hidden').find('select').select2();
            else
                $(".chose-own-delivery").addClass('hidden');
        });

        // submit zsc form
        jQuery("body").on("submit", ".b2b-return-goods", function (e) {
            // e.preventDefault();
            var form = $(this);
            var btn = $(".submit-zsc-form", form);

            if (btn.hasClass('loading'))
                return false;

            var phone = $(".zsc .for-delivery [name=phone]").val().replace(/\D/g, '');
            var ss = $(".zsc .for-delivery [name=sss]").length ? ($.trim($(".zsc .for-delivery [name=sss]").val()) == '' ? false : true) : true;
            var delivery = $(".zsc .for-delivery [name=delivery]:checked").val();

            if (!(phone.length == 10))
                $(".zsc .for-delivery [name=phone]").parent().parent().find('span').removeClass('hidden');
            else
                $(".zsc .for-delivery [name=phone]").parent().parent().find('span').addClass('hidden');

            if (!ss)
                $(".zsc .for-delivery [name=sss]").parent().find('span').removeClass('hidden');
            else
                $(".zsc .for-delivery [name=sss]").parent().find('span').addClass('hidden');


            if (!(WIZARD.validate() && phone.length == 10 && ss && (G.channel == 3 || delivery == 0 || delivery == 1))) {
                $(".zsc .for-delivery .errorBlock").removeClass('hidden');
                return false;
            }

            $(".zsc .for-delivery .errorBlock").addClass('hidden');
            btn.addClass('loading');

            var data = new FormData($('.b2b-return-goods')[0]);

            data.append("action", (G.manager_logged ? 'slr' : 'u'));
            data.append("to", 'zsc');
            data.append("case", 'send');
            data.append("phone", phone);

            $.ajax({
                type: "POST",
                url: "/aj",
                data: data,
                dataType: "json",
                enctype: 'multipart/form-data',
                processData: false,  // Important!
                contentType: false,
                cache: false,
                timeout: 20000, // in milliseconds
                success: function (data) {
                    btn.removeClass('loading');
                    if (data.success) {
                        // thx
                        DRAWER.destroy();
                        short_popup('<div class="exchange-thx"></div><div class="small-text text-center">' + data.message + '</div>');
                    } else
                        $(".zsc .for-delivery .errorBlock").html(data.error).removeClass('hidden');
                },
                error: function (request, status, err) {
                    btn.removeClass('loading');
                    $(".zsc .for-delivery .errorBlock").html(__('Щось пішло не так. Спробуйде відправити Ваше замовлення ще раз.')).removeClass('hidden');
                }
            });

        });

        jQuery("body").on("click", ".js-user__qr", function (e) {
            e.preventDefault();

            let btn = $(this);
            $(".user__qrcontainer").html('<img src="https://api.order-b2b.com/wallet/' + btn.data('guid') + '" />').removeClass('hidden');
        });

        jQuery("body").on("click", ".js-wishlist__addloyalty", function (e) {
            e.preventDefault();

            DRAWER.init('workdrawer-full workdrawer-loyalty', {
                action: 'u',
                to: 'loyalty'
            });
        });

        jQuery("body").on("submit", ".cabinet-edit-profile", function (e) {
            let form = $(this);

            let name = form.find('[name=name]').val();

            if (name.length >= 6 && name.split(' ').length > 1)
                return true;
            else {
                form.find('.alert').remove();
                form.prepend('<div class="alert alert-danger">' + __('Введіть Ваше ім\'я та прізвище') + '</div>');
                return false;
            }
        });


        jQuery("body").on("keyup", ".b2b-return-goods [name=sss], .b2b-return-goods [name=phone]", function (e) {
            let btn = $(this);

            if (btn.attr('name') == 'phone') {
                let phone = btn.val().replace(/\D/g, '');
                if (phone.length == 10) {
                    btn.removeClass('error');
                }
            }

            if (btn.attr('name') == 'sss') {
                if (!($.trim(btn.val()) == '')) {
                    btn.removeClass('error');
                }
            }

            CABINET.allow_zsc_submit();
        });

        // change zsc paytype
        jQuery("body").on("click", ".b2b-zsc-change-type .btn", function (e) {
            e.preventDefault();
            let btn = $(this);
            btn.parent().parent().find('[name=type]').val(btn.data('val'));
            btn.parent().find('.btn').removeClass('active').find('i').remove();
            btn.addClass('active').html('<i class="fa fa-check"></i> ' + $.trim(btn.text()));
        });

        jQuery("body").on("change", ".b2b-return-goods input[type=file]", function (e) {
            let input = $(this);
            if (this.files[0].size > 2097152) {
                input.trigger('reset');
                input.val('');
                this.value = "";
                input.next().addClass('error').find('span').html('Дозволені розмір файлу до 2 Мб');
                return false;
            } else {
                input.next().removeClass('error');
            }
        });

        jQuery("body").on("click", ".js-typical-registerclient", function (e) {
            e.preventDefault();
            CARD.open()
                .then(() => {
                    CARD.updatePromise();
                })
                .then(() => {
                    CARD.open_checkout();
                });
        });

        if (U.isMobile() && $(".ctabs__a-active").length > 0)
            $(".ctabs.scroll-horizontal").animate({
                scrollLeft: $(".ctabs__a-active").position().left - 16
            }, 100);

        $(".user-form select").select2({minimumResultsForSearch: Infinity});

        jQuery("body").on("click", ".js-order__decline", function (e) {
            e.preventDefault();
            e.stopPropagation();
            let btn = $(this);
            if (USER.is_logged() || G.manager_logged || G.is_b2b) {
                DRAWER.init('workdrawer-declineorder workdrawer-full', {
                    action: 'u',
                    to: 'declineorderform',
                    guid: btn.parents('.item').data('guid'),
                    order_id: btn.parents('.item').find('.service__title').text(),
                    locale: G.locale_id,
                }, function () {
                    $(".workdrawer-declineorder select").select2({minimumResultsForSearch: Infinity});
                });
            } else {
                USER.callback = function () {
                    $(".tform-auth >.alert.alert-info").removeClass('hidden');
                };
                $(".header__login").trigger('click');
            }
        });

        jQuery("body").on("submit", ".form-declineorder", function (e) {
            e.preventDefault();
            e.stopPropagation();
            let form = $(this);
            let submit = form.find('[type=submit]');

            if (!submit.hasClass('loading')) {
                if (form.find('[name=reason]:checked').val()) {
                    form.find('.alert').addClass('hidden');
                    submit.addClass('loading');

                    $.ajax({
                        type: "POST",
                        url: "/aj",
                        data: {
                            action: 'u',
                            to: 'declineorder',
                            guid: form.find('[name=guid]').val(),
                            order_id: form.find('[name=order_id]').val(),
                            send: 1,
                            locale: G.locale_id,
                            comment: form.find('[name=comment]').val(),
                            reason: form.find('[name=reason]:checked').val(),
                            reason_text: form.find('[name=reason]:checked').parent().find('.checkbox__title').text()
                        },
                        dataType: "json",
                        cache: false,
                        timeout: 40000, // in milliseconds
                        success: function (data) {
                            submit.removeClass('loading');

                            if (data.success) {
                                if (U.isMobile()) {
                                    DRAWER.init('workdrawer-writebug_thx', {action: 'u', to: 'declineorderthx'});
                                } else {
                                    DRAWER.destroy();
                                    short_popup(data.html);
                                }
                            } else {
                                form.find('.alert').removeClass('hidden').html(data.error_message);
                            }
                        },
                        error: function (request, status, err) {
                            submit.removeClass('loading');
                        }
                    });
                } else {
                    form.find('.alert').removeClass('hidden').html('Помилка при відправленні запиту. Спробуйте ще раз');
                    form.find('.alert').removeClass('hidden');
                }
            }
        });

        jQuery("body").on("click", ".cabinet__sslink", function (e) {
            e.preventDefault();
            e.stopPropagation();
            let textArea = document.createElement("textarea");
            textArea.value = $.trim($(this).text());
            textArea.style.opacity = "0";
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            try {
                let successful = document.execCommand('copy');
                let msg = successful ? 'successful' : 'unsuccessful';
            } catch (err) {
            }

            document.body.removeChild(textArea);
            return false;
        });

        jQuery("body").on("click", ".service__open", function (e) {
            e.preventDefault();
            e.stopPropagation();

            let btn = $(this);
            let container = btn.parent();

            if (container.hasClass('opened')) {
                container.removeClass('opened');
                return false;
            } else {
                if (!container.hasClass('filled')) {
                    JOBS.init_JOB(
                        '/aj',
                        {
                            action: G.channel == 2 || G.channel == 4 ? 'slr' : 'u',
                            to: 'service',
                            lookup: container.data('id'),
                        },
                        function (result) {
                            container.find('.service__steps').html(result.html);
                            container.addClass('opened');
                            container.addClass('filled');
                        },
                        function (result) {
                            container.find('.service__steps').html(result.html).html('Сталася помилка при оновленні даних, спробуйте пізніше').removeClass('hidden');
                        },
                        function (result) {
                        },
                        btn
                    );
                } else
                    container.addClass('opened');
            }
        });

        // toggle open balance-expand-all
        jQuery("body").on("click", ".balance-expand-all", function (e) {
            e.preventDefault();
            e.stopPropagation();


            let btn = $(this);
            let table = btn.parent().find('.table');
            let open = 0;

            if (!btn.hasClass('opened')) {
                btn.addClass('opened').html(__('Згорнути все'));
                open = 1;
            } else
                btn.removeClass('opened').html(__('Розгорнути все'));

            if (table.length && table.find('a.open-closest-innertable').length)
                $.each(table.find('a.open-closest-innertable'), function (i, a) {
                    a = $(a);

                    if ((open && !a.hasClass('opened')) || (!open && a.hasClass('opened'))) {
                        a.toggleClass('opened');
                        $("tr.detail-goods[data-name='" + a.data('name') + "']").toggleClass('hidden');
                    }
                });

        });

        // open balance agreement
        jQuery("body").on("click", ".b2b_balance .top", function (e) {
            e.preventDefault();
            let btn = $(this);
            let container = $(this).parents('.item');
            let loader = container.find('.expand-btn');

            if (loader.hasClass('load-animation'))
                return;

            if (container.hasClass('opened')) {
                e.stopPropagation();
                container.removeClass('opened');
                return;
            }

            loader.addClass('loading').find('i').addClass('fa-spinner').addClass('fa-spin');

            if (!(container.data('agreement') == '')) {

                if (container.find('.table-responsive').length) {
                    container.addClass('opened').removeClass('load-animation');
                } else {
                    JOBS.init_JOB(
                        '/aj',
                        {
                            action: 'u',
                            to: 'balance',
                            agreement: container.data('agreement'),
                            date: $(".sorting__item-active").data('val'),
                        },
                        function (result) {
                            container.addClass('opened').removeClass('load-animation').find('.expand').empty();

                            var add = '<div class="update-date">Дата оновлення даних: ' + result.time + '</div><br /><button class="badge active balance-load-xls b2b-button pull-left" data-a="' + container.data('agreement') + '" data-n="' + container.find('.date a').text() + '">Завантажити XLS</button><button class="badge active balance-expand-all b2b-button pull-left">Розгорнути все</button><br /><br />';
                            add += '<div class="table-responsive"><table class="table" cellspacing="1">' +
                                '<thead>' +
                                '<th>Назва реалізації</th>' +
                                '<th align="center" width="200">Коментар</th>' +
                                '<th class="fixed">К-сть</th>' +
                                '<th class="fixed">Ціна</th>' +
                                '<th class="fixed">Сальдо поч.</th>' +
                                '<th class="fixed">Прихід</th>' +
                                '<th class="fixed">Розхід</th>' +
                                '<th class="fixed">Сальдо кін.</th>' +
                                '</thead>';

                            var cc = 0;

                            if (typeof result.data === "object" && result.data.length) {
                                $.each(result.data, function (i, item) {
                                    var title = '<strong>' + item.t + '</strong>';

                                    cc++;
                                    var base = container.index() + '-' + cc;
                                    var goods = '';
                                    var comment = '';

                                    if (!(item.comment == ''))
                                        comment += item.comment + '<br />';

                                    if (!(item.m == ''))
                                        comment += 'Менеджер: ' + item.m + '<br />';

                                    if (!(item.isum == '') && !(item.course == ''))
                                        comment += '<strong>' + item.isum + ' ' + item.curr + '</strong> по курсу <strong>' + item.course + '</strong><br />';

                                    if (typeof item.goods === "object" && item.goods.length) {
                                        var counter = 0;

                                        $.each(item.goods, function (_i, _item) {
                                            if (!(typeof _item.c === "undefined") && _item.c) {
                                                counter++;
                                                var serials = [];

                                                if (!(typeof _item.ss === "undefined") && _item.ss.length)
                                                    $.each(_item.ss, function (__i, serial) {
                                                        serials.push($.trim(serial));
                                                    });

                                                var sku = (!(typeof _item.sku === "undefined") && _item.sku) ? '<strong>[' + _item.sku + ']</strong> ' : '';

                                                serials = serials.length ? '<strong>Серійні номери</strong><br />' + serials.join('<br />') : '';

                                                var pn_string = [];

                                                if (!(typeof _item.pn === "undefined") && !(_item.pn == ''))
                                                    pn_string.push('<strong>Артикул:</strong> ' + _item.pn);

                                                if (!(typeof _item.wr === "undefined") && !(_item.wr == ''))
                                                    pn_string.push('<strong>Гарантія:</strong> ' + _item.wr);

                                                pn_string = pn_string.length ? pn_string.join('<br />') : '';

                                                goods += '<tr class="detail-goods hidden" data-name="' + base + '">' +
                                                    '<td colspan="2"><span>' + sku + _item.t + '</span><div class="row"><div class="col-xs-6">' + pn_string + '</div><div class="col-xs-6">' + serials + '</div></div></td>' +
                                                    '<td class="fixed" valign="top">' + _item.c + 'шт.</td>' +
                                                    '<td class="fixed" valign="top">' + _item.p + '</td>' +
                                                    '<td class="fixed"></td>' +
                                                    '<td class="fixed"></td>' +
                                                    '<td class="fixed" valign="top">' + _item.s + '</td>' +
                                                    '<td class="fixed"></td>' +
                                                    '</tr>';
                                            }
                                        });

                                        if (counter)
                                            title = '<a href="#" class="open-closest-innertable" data-name="' + base + '">' + title + ' </a>';
                                    }
                                    item.ps = item.ps == '0' || item.ps == '0.00' ? '' : item.ps;
                                    item.pm = item.pm == '0' || item.pm == '0.00' ? '' : item.pm;
                                    item.pl = item.pl == '0' || item.pl == '0.00' ? '' : item.pl;
                                    item.pe = item.pe == '0' || item.pe == '0.00' ? '' : item.pe;

                                    add += '<tr>' +
                                        '<td>' + title + '</td>' +
                                        '<td>' + comment + '</td>' +
                                        '<td class="fixed" valign="top"></td>' +
                                        '<td class="fixed" valign="top"></td>' +
                                        '<td class="fixed" valign="top"><strong>' + item.ps + '</strong></td>' +
                                        '<td class="fixed" valign="top"><strong>' + item.pl + '</strong></td>' +
                                        '<td class="fixed" valign="top"><strong>' + item.pm + '</strong></td>' +
                                        '<td class="fixed" valign="top"><strong>' + item.pe + '</strong></td>' +
                                        '</tr>';

                                    add += goods;
                                });
                            }

                            add += '</table></div>';
                            container.find('.expand').html(add).removeClass('hidden');
                        },
                        function (result) {
                            loader.removeClass('loading').find('i').removeClass('fa-spinner').removeClass('fa-spin');
                            container.find('.expand').html('Сталася помилка при оновленні даних, спробуйте пізніше').removeClass('hidden');
                        },
                        function (result) {
                            loader.removeClass('loading').find('i').removeClass('fa-spinner').removeClass('fa-spin').removeClass('fa-caret-down').addClass('fa-caret-up');
                        },
                        btn
                    );
                }
            }
        });

        // change service date
        jQuery("body").on("click", ".open-closest-innertable", function (e) {
            e.preventDefault();
            e.stopPropagation();
            let btn = $(this);
            btn.toggleClass('opened');
            $("tr.detail-goods[data-name='" + btn.data('name') + "']").toggleClass('hidden');
        });

        // change history date
        jQuery("body").on("click", ".js-sorting__item-user", function (e) {
            let btn = $(this);
            $(".sorting__item").removeClass('sorting__item-active');
            $(".sorting__choiselist .sorting__item:eq(" + btn.index() + ")").addClass('sorting__item-active');
            $(".sorting__selected").html(btn.text());
            $(".tooltip.sorting__choise").remove();
            $(".sorting").removeClass('sorting-opened');

            if ($(".history-list").length)
                CABINET.im_history($(".history-list"));

            if ($(".service-list").length)
                CABINET.submit_service($(".service-list"));

            if ($(".b2b_balance").length)
                CABINET.submit_balance($(".b2b_balance"));

            if ($(".orders-list").length)
                CABINET.im_orders($(".orders-list"));

            if ($(".balance-list").length)
                CABINET.ok_balance($(".balance-list"));
        });

        // search in /u/history
        jQuery("body").on("keyup", ".search__history [type=text]", function (e) {
            e.preventDefault();
            clearTimeout(JOBS.history_timeout);
            JOBS.history_timeout = setTimeout(() => {
                CABINET.submit_history_search('.history-list')
            }, 500);
        });

        // задать вопрос по заказу
        jQuery("body").on("click", ".js-order__question", function (e) {
            e.preventDefault();
            e.stopPropagation();
            let btn = $(this);
            let container = btn.parents('.item');
            let df = container.data('df').split('T');
            let message = '?' + container.find('.service__title').text() + ', ' + df[0] + ', ' + container.find('.cabinet__badge').text();
            let messagetg = container.data('tgtext');

            $(".order__questiontooltip").remove();
            $("body").prepend('<div class="order__questiontooltip hidden"><div class="order__questiontooltiptext hidden">' + message + '</div><ul>\n' +
                '        <li class="icon-viber"><a href="viber://pa?chatURI=ktc&Text=' + encodeURIComponent(message) + '" target="_blank">Viber</a></li>\n' +
                '        <li class="icon-telegram2"><a href="tg://resolve?domain=Ktc_ua_bot&start=' + encodeURIComponent(messagetg) + '" target="_blank">Telegram</a></li>\n' +
                '        <li class="icon-support"><a href="#" class="open-verbox-chat" target="_blank">Чат</a></li>\n' +
                '    </ul></div>');

            TOOLTIP.open(btn, {
                target: '.order__questiontooltip',
                place: 'bottom',
                subclass: 'support-menu'
            });
        });

        // history expand
        jQuery("body").on("click touchend", ".history-list >.item .top", function (e) {
            e.preventDefault();
            e.stopPropagation();

            $(this).parent().toggleClass('opened');
        });

        // orders expand
        jQuery("body").on("click touchend", ".js-order__openbtn", function (e) {
            e.preventDefault();
            e.stopPropagation();
            var btn = $(this);
            var container = btn.parents('.item');

            if (container.hasClass('opened')) {
                container.removeClass('opened');
                btn.removeClass('order__openbtn-active');
                container.find('.order__goods').removeClass('order__goods-active');
                return;
            }

            if (container.hasClass('load-animation'))
                return;

            if (container.hasClass('loaded')) {
                container.addClass('opened');
                btn.addClass('order__openbtn-active');
                container.find('.order__goods').addClass('order__goods-active');
            } else {
                if (!(container.data('guid') == '')) {

                    JOBS.init_JOB(
                        '/aj',
                        {
                            action: JOBS.action(),
                            to: 'orders',
                            locale: G.locale_id,
                            guid: container.data('guid'),
                        },
                        function (result) {
                            container.find('.expand').empty();
                            container.find('.order__goods').append(
                                '<div class="order__goodstop"><div class="help help-large hiddenMobile">' + __('Підсумок замовлення:') + '</div>' + '</div>' +
                                '<div class="order__inner">' +
                                '<div class="order__goodslist"></div>' + CABINET.delivery_info(result, container, container.data('guid')) + '</div>' +
                                '</div>'
                            );

                            if (typeof result.data.goods === "object") {
                                $.each(result.data.goods, function (i, item) {

                                    let link = typeof item.l === "undefined" ? 'javascript: void(null);' : item.l;
                                    let img = typeof item.img === "undefined" ? '/themes/img/nophoto1.png' : item.img;

                                    let ss = [];

                                    if (item.ss.length)
                                        $.each(item.ss, function (i, _ss) {
                                            if (!($.trim(item) == ''))
                                                ss.push(_ss);
                                        });

                                    let params = '';
                                    if (item.cl)
                                        params = '<div class="order__param order__param-red">&nbsp;<span>' + __('Товар відмінено') + '</span>';
                                    else
                                        params =
                                            '   <div class="order__param">' +
                                            '       ' + __('Ціна') + ':<span>' + item.p + '&nbsp;' + result.data.cr + '</span>' +
                                            '   </div>' +
                                            '   <div class="order__param">' +
                                            '       ' + __('Кількість') + ':<span>' + item.c + '&nbsp;шт.</span>' +
                                            '   </div>' +
                                            '   <div class="order__param order__param-sku">' +
                                            '       ' + __('Код товару') + ':<span>' + item.sku + '</span>' +
                                            '   </div>';

                                    if (item.cerfificates) {
                                        params = `${params}<div class="order__param"><a href="javascript: void(null);" class="typical typical-large icon__cart js-orders__addservice" data-guid="${container.data('guid')}" data-sku="${item.sku}" data-price="${item.p}" data-orderid="${result.data.n}" data-leadid="${container.find('.service__title').text()}">Сертифікат</a></div>`;
                                    }

                                    if (ss.length)
                                        params += '   <div class="order__param order__param-ss">' +
                                            '       ' + __('Серійний номер') + ':<span class="order__paramss js-order__paramss">' + ss.join(', ') + '</span>' +
                                            '   </div>';

                                    if (!(typeof item.certificate_link === "undefined"))
                                        params += '<div class="order__param">' +
                                            '       ' + __('Сертифікат') + ':<span><a class="order__paramcertificate" href="' + item.certificate_link + '">' + __('Завантажити') + '</a></span></div>';

                                    container.find('.order__goodslist').append(
                                        '<div class="order__product">' +
                                        '   <div class="order__productimage"><a href="' + link + '" target="_blank"><img src="' + img + '"></a></div>' +
                                        '   <div class="order__producttitle ' + (item.cl ? 'order__producttitle-strike' : '') + ' mb12"><a href="' + link + '" target="_blank">' + item.t + '</a></div>' +
                                        '   <div class="order__productparams">' + params +
                                        '</div>' +
                                        '</div>'
                                    );
                                });
                            }

                            container.find('.order__goods').addClass("order__goods-active");
                            container.addClass('opened').addClass("loaded");
                            btn.addClass('order__openbtn-active');
                        },
                        function (result) {
                            container.addClass('opened');
                            container.find('.order__goods').addClass('order__goods-active').html(__('Сталася помилка при оновленні даних, спробуйте пізніше')).removeClass('hidden');
                        },
                        function (result) {
                        },
                        container
                    );
                }
            }
        });

    });

    $(".make-salary").click(function (e) {
        e.preventDefault();
        var btn = $(this);
        btn.prop('disabled', true);
        btn.prepend('<i class="fa fa-spin fa-spinner"></i> ');
        $.post(
            '/slr/salaryform',
            'to=salaryform&locale=' + G.locale_id,
            function (data) {
                btn.replaceWith(data);
                $('.make-salary-form select').select2({minimumResultsForSearch: Infinity});
            }
        )
    });

    $("body").on("click touchend", ".js-searchform__storeswitch", function (e) {
        e.preventDefault();
        let btn = $(this);
        CABINET.switch_store(btn.data('was')).then(() => {
            if ($.trim($(".searchform input[name=q]").val()) != '') {
                document.location.assign(`/search/?q=${$(".searchform input[name=q]").val()}`);
            } else {
                document.location.reload();
            }
        });
    });

    $("body").on("click touchend", ".js-bonus__togglelist", function (e) {
        e.preventDefault();
        let btn = $(this);
        btn.toggleClass('bonus__togglelist-opened');
        $(".js-bonus__totallist").toggleClass('hidden');
    });

    // Отправка заявки на РКО
    jQuery("body").on("submit", ".make-salary-form", function (e) {
        e.preventDefault();
        var form = $(this);
        var amount = $('[name=amount]', form);
        var date = $('[name=date]', form);
        var place = $('[name=place]', form);
        var balance = parseInt($('[name=balance]').val());
        var errors_count = 0;
        var message = 'Заявка заповнена не вірно';

        if (place.val() == '')
            errors_count++;

        if (date.val() == '')
            errors_count++;

        if (!($.isNumeric(amount.val()) && amount.val()))
            errors_count++;
        else {
            var am = parseInt(amount.val());

            if (!($.isNumeric(am) && balance >= am)) {
                errors_count++;
                message = 'Недостатньо коштів на рахунку';
            }
        }

        if (errors_count) {
            $(".make-salary-form >.row >.error").removeClass('hidden').find('div').html(message);
            return false;
        } else {
            $(".make-salary-form >.row >.error").addClass('hidden');
            form.find('[type=submit]').prepend('<i class="fa fa-spin fa-spinner"></i> ');
            $.post(
                '/slr/salaryform',
                'to=salaryformsend&' + form.serialize(),
                function (data) {
                    form.find('[type=submit]').find('i').remove();
                    if (data.success) {
                        form.html('<div class="alert alert-danger">Ваша заявка відправлена</div>');
                        slr_salary_list();
                    } else {
                        form.find(">.row >.error").removeClass('hidden').find('div').html(data.message);
                    }
                },
                'json'
            );
        }

    });

    // open drawer
    jQuery("body").on("click", ".js-returnorder", function (e) {
        e.stopPropagation();
        e.preventDefault();

        const btn = $(this);
        const params = {
            action: 'u',
            to: 'returnorder',
            case: 'open',
            guid: btn.data('guid')
        };

        DRAWER.init('workdrawer-full workdrawer-zsc workdrawer-return', params, () => {
            // init job with goods
            const container = $(".js-return__goods");

            JOBS.init_JOB(
                '/aj',
                {
                    action: JOBS.action(),
                    to: 'orders',
                    locale: G.locale_id,
                    guid: btn.data('guid'),
                },
                function (result) {
                    let goods_count = 0;

                    result.data.goods.map(item => {
                        if (item.type == 'Товар') {
                            for (let i = 1; i <= item.c; i++) {
                                let sss = item.ss.shift();

                                container.append(`
                                    <div class="return__item" data-sku="${item.sku}" data-count="1" data-price="${item.p}" data-fd="${item.fd}" data-fn="${item.fn}" data-ss="${sss ? sss : ''}">
                                        <div>
                                            <label class="checkbox">
                                                <input type="checkbox" class="unstyled" value="1" />
                                                <div class="checkbox__title"></div>
                                            </label>
                                        </div>
                                        <div class="selected-sku selected-sku-radio clearfix js-return__item">
                                            <input type="hidden" name="sku" value="${item.sku}" />
                                            
                                            <div class="image" style="background-image: url(${item.img});"></div>
                                            <div class="title">${item.t}</div>
                                            <small>Код товару: ${item.sku}</small>
                                            ${sss ? `<br /><small>Серійний номер: ${sss ? sss : ''}</small>` : ``}
                                        </div>
                                    </div>
                                `);
                                goods_count++;
                            }

                        }

                    });

                    if (goods_count == 0) {
                        container.find('.alert').html('Немає товарів, доступних для повернення').removeClass('hidden');
                    }

                    $(".js-return__form [name=order_date]").val(result.data.date);
                    $(".js-return__form [name=number]").val(result.data.n);
                    $(".js-return__form [name=guid]").val(btn.data('guid'));
                    $(".js-return__submit").removeClass('hidden');
                },
                function (result) {
                    container.find('.alert').html('Сталася помилка при оновленні даних, спробуйте ще раз').removeClass('hidden');
                },
                function (result) {
                },
                container
            );
        }, true);
    });

    jQuery("body").on('click', '.js-return__item', function (e) {
        e.preventDefault();

        const btn = $(this);
        const container = btn.parents('.return__item');

        container.find('.checkbox').trigger('click');
    });

    jQuery("body").on('submit', '.js-return__form', function (e) {
        e.preventDefault();

        const form = $(this);
        const btn = form.find('[type=submit]');
        const goods = [];
        const drawer = $(".workdrawer-return");

        if (btn.hasClass('loading')) {
            return;
        }

        drawer.find('.alert').addClass('hidden');

        $.each($(".js-return__goods .return__item"), (i, item) => {
            item = $(item);

            if (item.find('[type=checkbox]').prop('checked')) {
                goods.push({
                    sku: item.data('sku'),
                    title: item.find('.title').text(),
                    price: item.data('price'),
                    count: item.data('count'),
                    fd: item.data('fd'),
                    fn: item.data('fn'),
                    ss: item.data('ss')
                });
            }
        });

        if (goods.length > 0) {
            btn.addClass('loading');

            $.post(
                '/aj',
                {
                    action: 'u',
                    to: 'returnpdf',
                    goods: JSON.stringify(goods),
                    name: form.find('[name=name]').val(),
                    number: form.find('[name=number]').val(),
                    order_date: form.find('[name=order_date]').val(),
                    guid: form.find('[name=guid]').val()
                },
                function (data) {
                    btn.removeClass('loading');

                    if (data.success) {
                        $(".js-return__thx").removeClass('hidden');
                        $(".js-return__goods").addClass('hidden');
                        btn.replaceWith(`<a href="${data.url}" target="_blank" class="btn active" style="margin: 12px auto 0px auto; display: block;" type="button">Завантажити заявку</a>`)
                    } else {
                        drawer.find('.alert').html('Помилка при створенні заявки, спробуйте ще раз').removeClass('hidden');
                    }
                },
                'json'
            );

        } else {
            drawer.find('.alert').html('Оберіть товари для повернення').removeClass('hidden');
        }
    });

    jQuery("body").on('click', '.js-orders__addservice', function (e) {
        e.preventDefault();

        const btn = $(this);
        const params = {
            action: 'slr',
            to: 'addservice',
            sku: btn.data('sku'),
            price: btn.data('price'),
            order_id: btn.data('orderid'),
            lead_id: btn.data('leadid'),
            guid: btn.data('guid')
        };

        DRAWER.init('workdrawer-full workdrawer-addservice zsc', params, () => {
            $(".workdrawer-addservice select").select2();
        }, true);
    });

    jQuery("body").on('click', '.js-orders__changecredit', function (e) {
        e.preventDefault();

        const btn = $(this);
        const params = {
            action: 'popup',
            to: 'changecredit',
            sku: btn.data('sku'),
            cp: btn.data('cp'),
            guid: btn.data('guid'),
            job_id: btn.data('job_id'),
            obj: JSON.stringify(CABINET.web_order_read[btn.data('guid')] ?? [])
        };

        DRAWER.init('workdrawer-full workdrawer-changecredit', params, () => {
            $(".workdrawer-changecredit select").select2();
        }, true);
    });

    jQuery("body").on('click', '.js-slr__choiseservice', function (e) {
        e.preventDefault();

        const btn = $(this);
        btn.parent().find('.cart__service-active').removeClass('cart__service-active');
        btn.addClass('cart__service-active');

        $(".js-slr__addserviceform [type=submit]").addClass('active');
    });

    jQuery("body").on('submit', '.js-slr__addserviceform', function (e) {
        e.preventDefault();
        const form = $(this);
        const btn = form.find('[type=submit]');

        form.find('.alert').addClass('hidden');

        if (!form.hasClass('tform-loading') && btn.hasClass('active')) {
            btn.addClass('loading');
            form.addClass('tform-loading');

            CARD.postData({
                action: 'slr',
                to: 'addservicesend',
                sku: form.find('[name=sku]').val(),
                service_id: $(".cart__service-active input").val(),
                price: $(".cart__service-active input").data('price'),
                order_id: form.find('[name=order_id]').val(),
                payment_method: form.find('[name=payment_method]').val(),
                guid: form.find('[name=guid]').val()
            }, '/aj', 45000).then(data => {
                if (data.success) {
                    DRAWER.destroy();
                    short_popup(`<div class="exchange-thx"></div><div class="small-text text-center">Замовлення №${data.number} відправлено</div>`);
                } else {
                    form.find('.alert').removeClass('hidden').html(data.error);
                }
            }).catch((error) => {
                form.find('.alert').removeClass('hidden').html(`Вийшов час створення заявки, спробуйте ще раз. ${error}`);
            }).finally(() => {
                btn.removeClass('loading');
                form.removeClass('tform-loading');
            });
        } else {
            form.find('.alert').removeClass('hidden').html('Оберіть послугу');
        }
    });

    jQuery("body").on('click', '.js-addserviceselectcredit', function (e) {
        e.preventDefault();
        const form = $(".js-slr__addserviceform");
        const btn = $(this);
        btn.parent().find('.credit__listitem-active').removeClass('credit__listitem-active');
        btn.addClass('credit__listitem-active');

        form.find('[name=payment_method]').val('');

        btn.find('select').trigger('change');
    });

    jQuery("body").on('change', '.js-addserviceselectcredit select', function (e) {
        e.preventDefault();
        const form = $(".js-slr__addserviceform");
        const btn = $(this);
        form.find('[name=payment_method]').val(btn.val());
        console.log(form.find('[name=payment_method]').val());
    });

    jQuery("body").on('click', '.js-changecreditprogram', function (e) {
        e.preventDefault();
        const form = $(".workdrawer-changecredit");
        const btn = $(this);

        btn.parent().find('.credit__listitem-active').removeClass('credit__listitem-active');
        btn.addClass('credit__listitem-active');

        if (btn.find('select').length > 0) {
            form.find('[name=new_credit_program]').val('');
            btn.find('select').trigger('change');
        } else {
            form.find('[name=new_credit_program]').val('00000000-0000-0000-0000-000000000000');
        }

        console.log('new_credit_program', form.find('[name=new_credit_program]').val());
    });

    jQuery("body").on('change', '.js-changecreditprogram select', function (e) {
        e.preventDefault();
        const form = $(".workdrawer-changecredit");
        const btn = $(this);
        form.find('[name=new_credit_program]').val(btn.val());
        console.log('new_credit_program', form.find('[name=new_credit_program]').val());
    });

    jQuery("body").on('click', '.js-changecreditprogramsubmit', function (e) {
        e.preventDefault();
        const form = $(".workdrawer-changecredit");
        const btn = $(this);
        let guid = form.find('[name=new_credit_program]').val();
        const jobid = form.find('[name=job_id]').val();

        if (btn.hasClass('loading')) {
            return;
        }

        if (form.find('.credit__listitem-active').length == 0) {
            guid = '';
        }

        form.find('.js-changecreditprogramerror').addClass('hidden');

        if (guid != '') {
            btn.addClass('loading');

            CARD.postData({
                action: 'popup',
                to: 'changecreditsend',
                guid: form.find('[name=guid]').val(),
                obj: JSON.stringify(CABINET.web_order_read[form.find('[name=guid]').val()] ?? []),
                job_id: form.find('[name=job_id]').val(),
                new_credit_program: form.find('[name=new_credit_program]').val(),
            }, '/aj', 45000).then(data => {
                if (data.success) {
                    $(".workdrawer .content").html(`
                        <div class="exchange-thx"></div>
                        <div class="small-text text-center">Запит успішно надіслано</div>
                        <br /><br />
                        <button type="button" class="btn success js-closepopups mt16">Закрити</button>
                    `);

                    $(`.jobid-${jobid}`).removeClass('opened loaded').find('.order__goods').removeClass('order__goods-active').empty();
                    $(`.jobid-${jobid}`).find('.js-order__openbtn').removeClass('order__openbtn-active');

                    setTimeout(() => {
                        DRAWER.destroy();
                    }, 5000);
                } else {
                    form.find('.js-changecreditprogramerror').removeClass('hidden').html(data.error);
                }
            }).catch((error) => {
                form.find('.js-changecreditprogramerror').removeClass('hidden').html('Проблема з відправкою заявки. Спробуйте ще разі');
            }).finally(() => {
                btn.removeClass('loading');
            });
        } else {
            form.find('.js-changecreditprogramerror').removeClass('hidden').html('Не обрана кредитна програма');
        }
    });

    jQuery("body").on('click', '.js-orders__repeatorder', function (e) {
        e.preventDefault();
        const btn = $(this);

        CARD.open().then(() => {
            CARD.postData({
                action: 'basket',
                to: 'addpack',
                locale: G.locale_id,
                goods: JSON.stringify(btn.data('obj'))
            }).then(data => {
                CARD.firstopened = true;
                CARD.update(data);
                CARD.gtm_event_view_cart();
            });
        });
    });

    jQuery("body").on('click', '.js-user__removeavatar', function (e) {
        e.preventDefault();
        $.ajax({
            type: "POST",
            url: "/aj",
            data: {
                action: 'u',
                to: 'removeavatar',
            },
            dataType: "json",
            success: function (data) {
                document.location.reload();
            },
            error: function (request, status, err) {
                document.location.reload();
            }
        });

    });

}

init_CABINET_events();